;(function () {
  'use strict'

  angular
    .module('contrast.settings.groups')
    .factory('groupService', groupServiceFactory)

  function groupServiceFactory($filter, $translate) {
    'ngInject'

    var onboard = 'onboard'

    var transl = {
      title_allApplications: $translate.instant('title_allApplications'),
      title_onboardApplications: $translate.instant('title_onboardApplications')
    }

    return {
      createGroupCreationRequest: function createGroupCreationRequest(group) {
        var request = {}

        angular.extend(request, {
          name: group.name,
          users: [],
          scope: {
            app_scope: {
              role: undefined,
              onboard_role: undefined,
              exceptions: []
            }
          }
        })

        angular.forEach(group.users, function (user) {
          request.users.push(user.uid)
        })

        angular.forEach(group.exceptions, function (exception) {
          if (
            !angular.isUndefined(exception.role) &&
            exception.apps.length > 0
          ) {
            var roleName = exception.role.name
            for (var i = 0; i < exception.apps.length; i++) {
              if (
                exception.apps.length === 1 &&
                exception.apps[0].app_id === onboard
              ) {
                request.scope.app_scope.onboard_role = roleName
              } else if (exception.apps[i].app_id == 0) {
                request.scope.app_scope.role = roleName
              } else {
                request.scope.app_scope.exceptions.push({
                  id: exception.apps[i].app_id,
                  role: roleName
                })
              }
            }
          }
        })
        return request
      },

      createEditView: function createEditView(group, roles, users) {
        var form = {}
        angular.extend(form, {
          id: group.group_id,
          name: group.name,
          exceptions: [],
          users: [],
          include_children: false
        })

        if (group.readonly) {
          form.name = $filter('pascalCase')(group.app_role)
        }

        if (group.app_role !== null) {
          _addAllApps(group, roles, form)
        }

        if (group.onboard_role) {
          _addOnboard(group, roles, form)
        }

        angular.forEach(group.applications, function (app) {
          _addApp(roles, form, app)
        })

        angular.forEach(group.users, function (user) {
          var found = _.find(users, function (u) {
            return u.uid == user.uid
          })
          if (found) {
            var idx = users.indexOf(found)
            if (idx > -1) {
              users.splice(idx, 1)
            }
            form.users.push(found)
          } else {
            user.guest = true
            form.users.push(user)
          }
        })

        return form
      },

      createPermissionView: function createPermissionView(matrix, roles) {
        var view = {}
        var rolesMap = []

        var i = 0
        for (; i < roles.length; i++) {
          var id = roles[i].name.trim()
          rolesMap[id] = i
        }

        view.apps = []

        angular.forEach(matrix, function (app) {
          var row = { app: app, role: -1 }
          if (app.noAccess) {
            row.role = rolesMap['no_access']
          } else {
            var id = app.role
            row.role = rolesMap[id]
          }

          view.apps.push(row)
        })

        return view
      },

      getChildrenFromParent: function getChildrenFromParent(apps, parentAppId) {
        return _.filter(apps, { parent_app_id: parentAppId })
      }
    }

    function _addApp(roles, form, app) {
      var exception = {}
      if (app.no_access) {
        exception.role = {}
        exception.role.group_id = 0
        exception.role.name = 'no_access'
        exception.role.roleType = 'NO_ACCESS'
      } else {
        exception.role = app.role
      }

      exception.apps = app.applications

      var childApps = []
      var primaryApps = []
      angular.forEach(exception.apps, function (app) {
        if (app.child) {
          childApps.push(app)
        }
        if (app.primary) {
          primaryApps.push(app.app_id)
        }
      })

      angular.forEach(childApps, function (app) {
        if (
          !_.includes(primaryApps, app.parent_app_id) &&
          !form.include_children
        ) {
          form.include_children = true
        }
      })

      exception.selected_apps = []
      exception.available_apps = []

      form.exceptions.push(exception)
    }

    function _addOnboard(group, roles, form) {
      var onboardAppsRole = _.find(roles, function (role) {
        return role.name == group.onboard_role
      })

      var onboardApps = {
        role: onboardAppsRole,
        apps: [
          {
            name: transl.title_onboardApplications,
            primary: false,
            app_id: onboard
          }
        ],
        selected_apps: [
          {
            name: transl.title_onboardApplications,
            primary: false,
            app_id: onboard
          }
        ],
        available_apps: []
      }
      form.exceptions.push(onboardApps)
    }

    function _addAllApps(group, roles, form) {
      var appRole = _.find(roles, function (role) {
        return role.name == group.app_role
      })

      var allApps = {
        role: appRole,
        apps: [
          { name: transl.title_allApplications, primary: false, app_id: 0 }
        ],
        selected_apps: [
          { name: transl.title_allApplications, primary: false, app_id: 0 }
        ],
        available_apps: []
      }
      form.exceptions.push(allApps)
    }
  }
})()
